interface TableSkeletonProps {
  rows?: number;
  cols: number;
}

export function TableSkeleton({ rows = 5, cols }: TableSkeletonProps): JSX.Element {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="border-t border-ink-100">
          <td colSpan={cols} className="px-4 py-3">
            <div className="h-3 w-full animate-pulse rounded bg-ink-100" />
          </td>
        </tr>
      ))}
    </>
  );
}

export function CardSkeleton(): JSX.Element {
  return (
    <div className="card p-3">
      <div className="h-3 w-20 animate-pulse rounded bg-ink-100" />
      <div className="mt-2 h-6 w-16 animate-pulse rounded bg-ink-200" />
    </div>
  );
}

interface ChartSkeletonProps {
  height?: number;
}

export function ChartSkeleton({ height = 280 }: ChartSkeletonProps): JSX.Element {
  return (
    <section className="space-y-2">
      <div className="h-3 w-40 animate-pulse rounded bg-ink-100" />
      <div className="rounded-md border border-ink-200 bg-white p-3">
        <div className="animate-pulse rounded bg-ink-100" style={{ height }} />
      </div>
    </section>
  );
}

export function SummaryCardsSkeleton({ count = 8 }: { count?: number }): JSX.Element {
  return (
    <section className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => <CardSkeleton key={i} />)}
    </section>
  );
}
